// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"654":"c518c9836ec3562df901","702":"adf87a891938fed08f8d"}[chunkId] + "/" + chunkId + ".chunk.js";
};